module.exports = __webpack_public_path__ + "img/logo_transparencia.67d6592f.png";